import script from "./BikeSPHeatmapLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./BikeSPHeatmapLegend.vue?vue&type=script&setup=true&lang=js"

import "./BikeSPHeatmapLegend.vue?vue&type=style&index=0&id=169c5a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169c5a44"]])

export default __exports__